<template>
  <div class="row">
    <div class="col-12 g">
      <div class="card card-body">
        <h4>
          <i class="fa fa-toggle-on"></i>
          خصائص التطبيقات
        </h4>
        <p class="text-muted mb-0">
          تحكم في ظهور خصائص التطبيقات الجديدة لكل منصة على حدة وحسب الإصدار: تظهر في كل الإصدارات، أو تختفي نهائياً، أو تظهر / تختفي في إصدارات محددة.
          كل منصة لها إعداد مستقل، فيمكن إخفاء الخاصية في إصدار آيفون معيّن مع بقائها ظاهرة في كل إصدارات أندرويد.
          يصل التغيير للتطبيقات خلال دقيقة تقريباً (عند فتح الشاشة أو سحبها للتحديث).
        </p>
      </div>
    </div>

    <div v-for="(f, key) in features" :key="key" class="col-12 col-lg-8 g">
      <div class="card" v-if="config[key]">
        <div class="card-header">
          <div>
            <h5 class="mb-25">{{ f.name }} <small class="text-muted">— تطبيق {{ appName(f.app) }}</small></h5>
            <span class="text-muted">{{ f.description }}</span>
          </div>
          <span class="badge" :class="anyVisible(key) ? 'badge-light-success' : 'badge-light-secondary'">
            {{ anyVisible(key) ? 'ظاهرة' : 'مخفية' }}
          </span>
        </div>
        <div class="card-body">
          <div v-for="p in platforms" :key="p.key" class="border rounded p-1 mb-1">
            <h6 class="mb-75"><i :class="p.icon"></i> {{ p.name }}</h6>

            <div class="form-group mb-50">
              <div v-for="m in modes" :key="m.key" class="custom-control custom-radio custom-control-inline mb-50">
                <input :id="key + '-' + p.key + '-' + m.key" type="radio" class="custom-control-input"
                  :value="m.key" v-model="config[key][p.key].mode">
                <label class="custom-control-label" :for="key + '-' + p.key + '-' + m.key">
                  {{ m.label }} <small class="text-muted">{{ m.hint }}</small>
                </label>
              </div>
            </div>

            <div class="form-group mb-50" v-if="config[key][p.key].mode == 'only' || config[key][p.key].mode == 'except'">
              <label :for="key + '-' + p.key + '-versions'">
                {{ config[key][p.key].mode == 'only' ? 'الإصدارات التي تظهر فيها' : 'الإصدارات التي تختفي فيها' }}
              </label>
              <input :id="key + '-' + p.key + '-versions'" class="form-control" dir="ltr" placeholder="4.0.7, 4.0.8"
                :value="(config[key][p.key].versions || []).join(', ')" @change="setVersions(key, p.key, $event.target.value)">
              <small class="text-muted d-block mt-25">افصل بين الإصدارات بفاصلة. أو اختر من الإصدارات المثبتة على {{ p.name }}:</small>
              <div class="mt-50">
                <button v-for="v in seen(f.app, p.key)" :key="v.version" type="button" class="btn btn-sm mr-50 mb-50"
                  :class="config[key][p.key].versions.includes(v.version) ? 'btn-primary' : 'btn-outline-secondary'"
                  @click="toggleVersion(key, p.key, v.version)">
                  {{ v.version }} <small>({{ v.count }} جهاز)</small>
                </button>
                <span v-if="!seen(f.app, p.key).length" class="text-muted">لا توجد بيانات أجهزة بعد.</span>
              </div>
            </div>

            <div class="alert alert-secondary g mb-0 py-50">
              <span class="text-dark">{{ summary(key, p.key) }}</span>
            </div>
          </div>

          <button class="btn btn-primary" @click="save()" :disabled="saving || !loaded">
            <i class="fa fa-save"></i>
            {{ saving ? 'جاري الحفظ...' : 'حفظ' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      jwt: localStorage.getItem('jwt'),
      features: {},
      apps: {},
      config: {},
      stats: {},
      loaded: false,
      saving: false,
      modes: [
        { key: 'all', label: 'إظهار في كل الإصدارات', hint: '' },
        { key: 'none', label: 'إخفاء نهائياً', hint: '' },
        { key: 'only', label: 'إظهار في إصدارات محددة فقط', hint: '' },
        { key: 'except', label: 'إخفاء في إصدارات محددة فقط', hint: '' },
      ],
      platforms: [
        { key: 'android', name: 'أندرويد', icon: 'fa fa-android' },
        { key: 'ios', name: 'آيفون', icon: 'fa fa-apple' },
      ],
    };
  },
  created() {
    this.load();
  },
  methods: {
    appName(app) {
      return (this.apps[app] || {}).name || app;
    },
    // Versions installed on devices of this platform (Admin → إصدارات التطبيقات), newest first.
    seen(app, platform) {
      var s = this.stats[app] || { versions: [] };
      return s.versions
        .map(function(v){ return { version: v.version, count: ((v[platform] || {}).total || 0) }; })
        .filter(function(v){ return v.count > 0; });
    },
    setVersions(key, platform, text) {
      this.config[key][platform].versions = [...new Set(text.split(/[\s,،]+/).map(function(v){ return v.trim(); }).filter(function(v){
        return /^\d{1,5}(\.\d{1,5}){0,3}$/.test(v);
      }))];
    },
    toggleVersion(key, platform, v) {
      var list = this.config[key][platform].versions;
      this.config[key][platform].versions = list.includes(v) ? list.filter(function(x){ return x != v; }) : list.concat([v]);
    },
    ruleVisible(r) {
      return r.mode != 'none' && (r.mode != 'only' || r.versions.length > 0);
    },
    anyVisible(key) {
      var c = this.config[key], g = this;
      return this.platforms.some(function(p){ return g.ruleVisible(c[p.key]); });
    },
    summary(key, platform) {
      var r = this.config[key][platform];
      if(!this.ruleVisible(r)) return 'النتيجة: مخفية في كل الإصدارات.';
      var list = r.versions.join('، ');
      if(r.mode == 'all') return 'النتيجة: ظاهرة في كل الإصدارات.';
      if(r.mode == 'only') return 'النتيجة: ظاهرة في الإصدارات ' + list + ' فقط.';
      return 'النتيجة: ظاهرة في كل الإصدارات' + (list ? ' ما عدا ' + list : '') + '.';
    },
    load() {
      var g = this;
      $.post(api + '/admin/apps/features', { jwt: this.jwt }).then(function(r){
        if(r.status != 100) return alert(r.response, 200);
        g.features = r.features;
        g.apps = r.apps;
        g.config = r.response;
        g.loaded = true;
      });
      $.post(api + '/admin/apps/stats', { jwt: this.jwt }).then(function(r){
        if(r.status == 100) g.stats = r.response;
      });
    },
    save() {
      var g = this;
      g.saving = true;
      $.post(api + '/admin/apps/features/save', {
        jwt: this.jwt,
        config: JSON.stringify(this.config),
      }).then(function(r){
        g.saving = false;
        if(r.status != 100) return alert(r.response, 200);
        g.config = r.response;
        alert('تم الحفظ، يصل للتطبيقات خلال دقيقة تقريباً.', 100);
      }).fail(function(){
        g.saving = false;
        alert('تعذر الاتصال بالسيرفر', 200);
      });
    },
  },
};
</script>

<style scoped>
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
